<script>
import '/local/templates/redesign/src/assets/scss/pages/premium/premium-common.scss';
import '/local/templates/redesign/src/assets/scss/pages/premium/premium-main.scss';

import PremiumModalCallback from '../../components-manual/premium/PremiumModalCallback.vue';
import PremiumCardAccordeon from '../../components-manual/premium/PremiumCardAccordeon.vue';
import PremiumCashbackSlider from '../../components-manual/premium/PremiumCashbackSlider.vue';
import PremiumFormRedesign from '../../components-manual/premium/PremiumFormRedesign.vue';
import FloatHeader from '../../components-manual/header/FloatHeader.vue';
import PremiumInteractiveBanner from '../../components-manual/premium/PremiumInteractiveBanner.vue';
import PremiumPriceCardSlider from '../../components-manual/premium/PremiumPriceCardSlider.vue';

export default {
    components: {
        PremiumCardAccordeon,
        PremiumCashbackSlider,
        PremiumFormRedesign,
        FloatHeader,
        PremiumInteractiveBanner,
        PremiumModalCallback,
        PremiumPriceCardSlider,
    },
};
</script>
